<div id="layout-wrapper">
  <!--topbar-->
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <a href="/" class="logo">
            <span *ngIf="!isCondensed" class="logo-box cus-logo-box text font-size-22"> Picket ADMIN </span>
            <span *ngIf="isCondensed" class="logo-box cus-logo-box text font-size-12 pl-2 pr-2" style="line-height: 16px"> Picket </span>
          </a>
        </div>

        <button
          (click)="toggleMobileMenu($event)"
          (settingsButtonClicked)="onSettingsButtonClicked()"
          (mobileMenuButtonClicked)="onToggleMobileMenu()"
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <!-- 알람 내역 -->
        <ng-container *ngIf="notifications$ | async as notifications">
          <div class="dropdown d-inline-block" ngbDropdown>
            <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" ngbDropdownToggle>
              <i class="bx bx-bell bx-tada"></i>
              <span class="badge badge-danger badge-pill">{{ unReadLength }}</span>
            </button>
            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0" aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
              <div class="p-3">
                <div class="row align-items-center">
                  <div class="col">
                    <h3 class="m-0">알람</h3>
                  </div>
                  <div *ngIf="notifications && notifications.length > 0" class="col-auto">
                    <button (click)="removeAll()" class="btn btn-danger">전체 삭제</button>
                  </div>
                </div>
              </div>
              <p *ngIf="notifications && !notifications.length" class="p-4">받은 알림이 없어요.</p>
              <perfect-scrollbar
                *ngIf="notifications && notifications.length > 0"
                style="position: relative; height: 230px; border-top: 1px solid #f0f0f0"
                [config]="configData"
              >
                <a *ngFor="let item of notifications" (click)="alarm(item)" class="text-reset notification-item">
                  <div class="media">
                    <div class="media-body d-flex justify-content-between align-items-center">
                      <div>
                        <h6 class="mt-0 mb-1">{{ item.title }}</h6>
                        <div class="font-size-12 text-muted">
                          <p class="mb-0">
                            {{ displayedAt(item.dateCreated) }}
                          </p>
                        </div>
                      </div>
                      <span *ngIf="!item.readSwitch" class="mb-0 badge-warning">NEW</span>
                    </div>
                  </div>
                </a>
              </perfect-scrollbar>
            </div>
          </div>
        </ng-container>

        <!-- 알람 내역 -->
        <!-- <div class="dropdown d-inline-block" ngbDropdown>
          <button type="button" class="btn header-item noti-icon" id="page-header-notifications-dropdown" ngbDropdownToggle>
            <i class="bx bx-bell bx-tada"></i>
            <span class="badge badge-danger badge-pill">3</span>
          </button>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0" aria-labelledby="page-header-notifications-dropdown" ngbDropdownMenu>
            <div class="p-3">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="m-0">알람</h6>
                </div>
                <div class="col-auto">
                  <a href="javascript: void(0);" class="small">전체 삭제</a>
                </div>
              </div>
            </div>
            <perfect-scrollbar style="position: relative; height: 230px" [config]="configData">
              <a href="" class="text-reset notification-item">
                <div class="media">
                  <div class="media-body">
                    <h6 class="mt-0 mb-1">알람 제목</h6>
                    <div class="font-size-12 text-muted">
                      <p class="mb-1">알람 내역</p>
                      <p class="mb-0">
                        {{ ' 2202 / 02 / 08' | date : 'yyyy-MM-dd' }}
                      </p>
                    </div>
                  </div>
                </div>
              </a>
            </perfect-scrollbar>
          </div>
        </div> -->
        <!--///알람 내역 끝-->

        <button (click)="logout()" class="btn header-item font-size-14 d-flex align-items-center">
          <i class="bx bx-log-out mr-1"></i>
          로그아웃
        </button>
      </div>
    </div>
  </header>

  <ng-template #contentTemplate>
    <!--- Sidemenu -->
    <div id="sidebar-menu">
      <!-- Left Menu Start -->

      <!--메인메뉴-->
      <ul class="metismenu list-unstyled" *ngIf="menu">
        <li *ngFor="let list of menu; let menuIndex = index">
          <!--서브메뉴 없을때-->
          <a *ngIf="!list.subItems || list.subItems?.length == 0" (click)="close(aTag)" routerLink="{{ list.link }}" routerLinkActive="active" #aTag>
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span></a
          >
          <!--서브메뉴 있을때-->
          <a
            *ngIf="list.subItems && list.subItems?.length > 0"
            [ngClass]="{ 'up-arrow': list.openSwitch }"
            (click)="open(list, menu, menuIndex)"
            href="javascript: void(0);"
            class="has-arrow"
          >
            <i class="bx {{ list.icon ? list.icon : '' }}"></i>
            <span>{{ list.label }}</span></a
          >
          <!--서브메뉴 리스트-->
          <ul [ngClass]="{ 'side-close': !list.openSwitch }" aria-expanded="true" class="sub-menu">
            <li *ngFor="let item of list.subItems; let i = index">
              <a class="side-nav-link-ref, atag{{ menuIndex }}{{ i }}" [routerLink]="item.link" routerLinkActive="active">
                <span>{{ item.label }}</span></a
              >
            </li>
          </ul>
        </li>

        <!-- end Layout menu -->

        <!-- </ng-container> -->
      </ul>
    </div>
  </ng-template>
  <!-- Sidebar -->

  <div class="vertical-menu">
    <perfect-scrollbar [config]="configData">
      <div *ngIf="!isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
      <div *ngIf="isCondensed">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </div>
    </perfect-scrollbar>
  </div>

  <div class="main-content">
    <div class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
